import { HtmlConverter } from './types';

export const defaultConverter: HtmlConverter = {
  convertFromEditorHtml: (value) => {
    const parser = new DOMParser();
    const root = parser.parseFromString(value || '', 'text/html');
    if (root.body.textContent === '') {
      return '';
    }
    return value || '';
  },
  convertToEditorHtml: (value) => {
    if (value) {
      const parser = new DOMParser();
      const root = parser.parseFromString(value, 'text/html');
      const nodes = Array.from(root.body.childNodes);
      // if the whole content is only text, we need to wrap it in a paragraph
      if (nodes.length === 1 && nodes[0].nodeType === Node.TEXT_NODE) {
        return `<p class="paragraph" dir="ltr"><span class="text">${value}</span></p>`;
      }
      // if there is a top level text node, we need to wrap everything in a paragraph
      // technically we should also wrap the text nodes in a span, but it does not seem strictly necessary
      if (nodes.some((node) => node.nodeType === Node.TEXT_NODE)) {
        return `<p class="paragraph" dir="ltr">${value}</p>`;
      }
    }
    return value || '';
  },
};
